import { AxiosResponse } from 'axios';
import { ErrorWithMessage } from 'src/api/types';

import { axiosInstance, axiosReportingInstance } from './axios/axiosInterceptors';

interface ApiParams {
  uri: string;
  data?: unknown;
  headers?: Record<string, string>;
  responseType?: 'json' | 'blob';
}

const handleRequest = async <T>(request: Promise<T>): Promise<T> => {
  try {
    const response = await request;
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const onError = (error: ErrorWithMessage) => {
  console.error('Something went wrong:', error.response.data.message ?? 'Unknown error');
};

const get = async <T>({ uri, headers }: ApiParams): Promise<AxiosResponse<T>> => {
  return await axiosInstance.get<T>(uri, { headers });
};

const getReporting = async <T>({ uri, headers, responseType = 'json' }: ApiParams): Promise<AxiosResponse<T>> => {
  return await axiosReportingInstance.get<T>(uri, { headers, responseType });
};

const post = async ({ uri, data, headers }: ApiParams) => handleRequest(axiosInstance.post(uri, data, { headers }));

const put = async ({ uri, data }: ApiParams) => handleRequest(axiosInstance.put(uri, data));

const patch = async ({ uri, data }: ApiParams) => handleRequest(axiosInstance.patch(uri, data));

const remove = async ({ uri, data }: ApiParams) => handleRequest(axiosInstance.delete(uri, { data }));

export { get, onError, patch, post, put, remove, getReporting };
